import { defineMessages } from 'react-intl';

export default defineMessages({
  refused: {
    id: 'ReactFilters.messages.state.refused',
    defaultMessage: 'Refused',
  },
  toModerate: {
    id: 'ReactFilters.messages.state.toModerate',
    defaultMessage: 'To moderate',
  },
  controlled: {
    id: 'ReactFilters.messages.state.controlled',
    defaultMessage: 'Controlled',
  },
  published: {
    id: 'ReactFilters.messages.state.published',
    defaultMessage: 'Published',
  },
});
